import { render, staticRenderFns } from "./ModalHighlightBannerWidget.vue?vue&type=template&id=356fa06a&scoped=true&"
import script from "./ModalHighlightBannerWidget.vue?vue&type=script&lang=js&"
export * from "./ModalHighlightBannerWidget.vue?vue&type=script&lang=js&"
import style0 from "./ModalHighlightBannerWidget.vue?vue&type=style&index=0&id=356fa06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356fa06a",
  null
  
)

export default component.exports